<template>
  <div style="height: 500px; width: 100%">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 100%"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url"/>
      <l-marker :lat-lng="withTooltip" v-if="$props.logo">
        <l-tooltip :options="{ permanent: true, interactive: false }">
            <img :src="$props.logo" class="company-logo"/> 
        </l-tooltip>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LTooltip } from "vue2-leaflet";
import 'leaflet/dist/leaflet.css';

export default {
   name: 'appMap2',
   components: {
      LMap,
      LTileLayer,
      LMarker,
      LTooltip
   },
   props:{
      lat: {
         type: Number,
         default: 0,
         description: "Latitudine"
      },
      long: {
         type: Number,
         default: 0,
         description: "Longitudine"
      },  
      company: {
         type: String,
         description: "Nome compania"
      },
      logo: {
         type: String,
         description: "Logo"
      }                
   },  
   data() {
      return {
         zoom: 16,
         center: latLng(this.$props.lat, this.$props.long),
         url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
         /*attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',*/
         withTooltip: latLng(this.$props.lat, this.$props.long),
         currentZoom: 14.5,
         currentCenter: latLng(this.$props.lat, this.$props.long),
         showParagraph: false,      
         mapOptions: {
           zoomSnap: 0.5
         },
         showMap: true
      };
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  }
};
</script>
<style>
#map {
  height: 460px;
  width: 100%;
}
.company-logo{max-width:80px;}
.vue2leaflet-map{z-index:0;}
.leaflet-marker-shadow, .leaflet-marker-icon{ display:none; }
</style>